import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxSelectModule } from 'ngx-select-ex';
import { combineLatest, Observable, of, Subscriber } from 'rxjs';
import { debounceTime, distinctUntilChanged, mergeMap, take } from 'rxjs/operators';
import { Uuid } from '../../../../graphql';
import { BxAddressInputComponent } from '../../../core/components/bx-address-input/bx-address-input.component';
import { BxCalculatorConfig } from '../../../core/components/bx-calculator';
import { BxCalculatorService } from '../../../core/components/bx-calculator/bx-calculator.service';
import { BxDocumentSourceType } from '../../../core/components/bx-documents/documents.model';
import { CatalogueItemLinkTileModule } from '../../../core/components/catalogue-item-link-tile/catalogue-item-link-tile.component';
import { TaxRateSelectorModule } from '../../../core/components/tax-rate-selector/tax-rate-selector.component';
import { AutoFocusDirective } from '../../../core/directives/auto-focus.directive';
import { CurrencyInputModule } from '../../../core/directives/currency-input.directive';
import { SingleClickModule } from '../../../core/directives/single-click.directive';
import { EventRecordTypes } from '../../../core/models/event-record-types.model';
import { AppSettingsService } from '../../../core/services/app-settings.service';
import { BxLogger } from '../../../core/services/bx-logger.service';
import { BxUnverifiedAlertService } from '../../../core/services/bx-unverified-alert.service';
import { CataloguesService } from '../../../core/services/catalogues.service';
import { DialogService } from '../../../core/services/dialog.service';
import { EventRecordsService } from '../../../core/services/event-records.service';
import { LaunchDarklyService } from '../../../core/services/launchdarkly.service';
import { FeatureService } from '../../../core/services/permission/feature.service';
import { PermissionService } from '../../../core/services/permission/permission.service';
import { PriceListService } from '../../../core/services/price-list.service';
import { StoresService } from '../../../core/services/stores';
import { TaxService } from '../../../data/logic/tax.service';
import { Job, PurchaseOrder, PurchaseOrderInvoice, PurchaseOrderItem } from '../../../data/models';
import { Integration } from '../../../data/models/integrations.model';
import { ContactLegacy, ContactPersonLegacy } from '../../../data/repositories/contacts/contacts-legacy-convertor.service';
import { RepoAccountingSyncService } from '../../../data/repositories/repo-accountingSync.service';
import { RepoCommonService } from '../../../data/repositories/repo-common.service';
import { RepoContactsService } from '../../../data/repositories/repo-contacts.service';
import { RepoEstimatesService } from '../../../data/repositories/repo-estimates.service';
import { RepoIntegrationsService } from '../../../data/repositories/repo-integrations.service';
import { RepoJobsService } from '../../../data/repositories/repo-jobs.service';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { SharedComponentsModule } from '../../../shared-components.module';
import { BxContactCardStatusModule } from '../../../shared/bx-contact-card-status/bx-contact-card-status.component';
import { getAddressComponents } from '../../../utils/helper-functions/address.functions';
import { moveInArray } from '../../../utils/helper-functions/array.functions';
import { focusElement } from '../../../utils/helper-functions/element.functions';
import { ContactsService } from '../../contacts/contacts.service';
import { UiEstimateItemPillModule } from '../../estimates/estimate-view/costings/ui-item-code-pill/ui-item-code-pill.component';
import { EstimateMeasurementCategoryVM } from '../../estimates/estimate-view/plans/measurement/feat-estimate-measurements-v2/domain';
import { EstimateMeasurementCalculatorService } from '../../estimates/estimate-view/plans/measurement/feat-estimate-measurements-v2/estimate-measurement-calculator.service';
import { EstimateMeasurementCategoryService } from '../../estimates/estimate-view/plans/measurement/feat-estimate-measurements-v2/estimate-measurement-category.service';
import { TakeOffMeasurement, TakeOffService } from '../../takeoff';
import { PurchaseOrdersInvoiceService } from './purchase-orders-invoice.service';
import { ImportSettings } from './purchase-orders.service';

@Component({
    selector: 'app-purchase-order-detail',
    templateUrl: './purchase-order-detail.component.html',
    styleUrls: ['./purchase-order-detail.component.scss'],
    standalone: false,
})
export class PurchaseOrderDetailComponent implements OnInit {
    // @ts-ignore TS2564
    purchaseOrder: PurchaseOrder;
    // @ts-ignore TS2564
    job: Job;
    editing = false;
    action = new EventEmitter();
    parentTasks: { ID_ParentTask: string; Description: string }[] = [];
    types: any[] = [];
    expenseAccounts: any[] = [];
    contactPeople: ContactPersonLegacy[] = [];

    documentsParams!: {
        leadId?: string;
        reference: string;
        sourceType: BxDocumentSourceType;
        references: { Id: string; Type: BxDocumentSourceType }[];
    };
    // @ts-ignore TS2564
    deliveryRates: { TaxRates: string };
    // @ts-ignore TS2564
    taxCode: string;
    // @ts-ignore TS2564
    accountingSyncSetting: AccountingSyncSettings;
    type: any;
    importSettings?: ImportSettings;
    isAllowedToSave = false;
    isAllowedToSend = false;
    isAllowedToAddItem = false;
    isAllowedToReceipt = false;
    orderFormDisabled = false;
    orderTypeDisabled = false;
    orderTypeHidden = false;
    orderStatuses: { name: string; disabled: boolean }[] = [];
    statusChangedToReceived = false;
    contacts: ContactLegacy[] = [];
    dateFormat = 'DD/MM/YYYY';
    // @ts-ignore TS2564
    costItemSuggestions$: Observable<any>;
    permissions = {
        canCreatePurchaseOrder: false,
        canCreateWorkOrder: false,
        canModifyPurchaseOrder: false,
        canModifyWorkOrder: false,
        canSendPurchaseOrder: false,
        canSendWorkOrder: false,
        canReceiptPurchaseOrder: false,
        canReceiptWorkOrder: false,
        canCancelPurchaseOrder: false,
        canCancelWorkOrder: false,
        canViewDocuments: false,
        canDeleteDocuments: false,
        canAddDocuments: false,
    };

    features = {
        canSendPurchaseOrder: false,
        canSendWorkOrder: false,
    };

    unitMeasures = [];

    orderAccountingSyncLabel?: string;

    public isTakeOffAvailable = false;
    isSaving: boolean = false;
    itemCount = 0;

    constructor(
        public appSettings: AppSettingsService,
        private logger: BxLogger,
        private bsModalRef: BsModalRef,
        public permissionService: PermissionService,
        public taxService: TaxService,
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        public featureService: FeatureService,
        private bxCalculatorService: BxCalculatorService,
        private priceListService: PriceListService,
        private translateService: TranslateService,
        private purchaseOrdersInvoiceService: PurchaseOrdersInvoiceService,
        private storesService: StoresService,
        public sharedData: SharedDataService,
        private repoJobs: RepoJobsService,
        private repoAccountingSync: RepoAccountingSyncService,
        private repoContacts: RepoContactsService,
        private lds: LaunchDarklyService,
        private cataloguesService: CataloguesService,
        private contactsService: ContactsService,
        private repoCommon: RepoCommonService,
        readonly eventRecordsService: EventRecordsService,
        private dialogService: DialogService,
        private readonly repoEstimates: RepoEstimatesService,
        private readonly takeOffService: TakeOffService,
        private readonly estimateMeasurementCategoryService: EstimateMeasurementCategoryService,
        private readonly estimateMeasurementCalculatorService: EstimateMeasurementCalculatorService,
        private integrationsService: RepoIntegrationsService
    ) {
        this.translateService.get('general.dateFormat').subscribe((res: any) => {
            this.dateFormat = res;
        });
        eventRecordsService.recordEvent(EventRecordTypes.PurchaseOrderOpened);
    }

    ngOnInit(): void {
        this.job = this.purchaseOrder.Job;
        this.editing =
            this.purchaseOrder.OrderStatus === 'Unsent' || (!!this.importSettings && this.importSettings.importingIntoExistingOrder);
        this.repoContacts.GetAll().then((results) => {
            this.contacts = _.orderBy(results, ['Description']);
            this.#assignContact();
        });
        this.parentTasks = this._getParentTasks();
        //this.appendTo = angular.element('#panelbody');
        this.types = this.repoJobs.PurchaseOrderTypes;

        this.expenseAccounts = [];
        if (this.purchaseOrder && this.purchaseOrder.ID_Contact) {
            this.repoContacts.Get(this.purchaseOrder.ID_Contact).then((c) => {
                this.setTaxCode(c);
            });
        } else {
            this.setTaxCode(null);
        }
        this.contactPeople = [];
        this.purchaseOrder.PurchaseOrderItems.sort((a, b) => {
            return a.Order - b.Order;
        });
        this.documentsParams = {
            leadId: this.job.ID_Lead,
            reference: this.purchaseOrder.ID_PurchaseOrder,
            sourceType: BxDocumentSourceType.PurchaseOrder,
            references: [{ Id: this.purchaseOrder.ID_PurchaseOrder, Type: BxDocumentSourceType.PurchaseOrder }],
        };

        if (this.job.ID_Estimate) {
            this.repoEstimates.GetEstimatePlans(this.job.ID_Estimate).then(({ results }) => {
                const plans = results;
                this.isTakeOffAvailable = plans?.some((p) => !p.IsDeleted && p.Scale);
            });
        }

        this.repoCommon.GetUnitMeasures().then((results) => {
            // @ts-ignore TS2322
            this.unitMeasures = results;
        });

        this.deliveryRates = { TaxRates: this.purchaseOrder.DeliveryTaxRates };

        this.setPermissions();
        this.loadAccounts();
        this.loadContactPersons();
        this.loadInvoiceItems();

        if (this.purchaseOrder.HasInvoiceAccSyncData && !this.importSettings) {
            this.orderAccountingSyncLabel = `This ${this.type.value} order has been synced ${
                this.purchaseOrder.AccSyncData == 'Imported' ? 'from' : 'to'
            } your accounting software.`;
        }

        this.itemCount = this.purchaseOrder.PurchaseOrderItems?.filter((poi) => poi.IsDeleted === false).length;
        this.purchaseOrder.calculateTotal();

        this.setOrderTypeHidden();
    }

    #assignContact(contactId?: Uuid) {
        if (contactId || this.purchaseOrder.ID_Contact) {
            const contact = this.contacts.find((x) => x.ID_Contact == (contactId ?? this.purchaseOrder.ID_Contact));
            this.purchaseOrder.ContactViaGql = contact;
            this.repoJobs.onChangeOfPurchaseOrderContactId(this.purchaseOrder, contact);
        }
    }

    setTaxCode(contact?: ContactLegacy | null) {
        if (this.purchaseOrder.Job.CalculationMethod === 0) {
            this.taxCode = this.sharedData.UserData.tenant.TaxCode;
        } else {
            this.taxCode = this.purchaseOrder.TaxRatesShortCode;
            if (this.purchaseOrder.OrderStatus === 'Unsent') {
                this.purchaseOrder.IsTaxFree = !contact ? false : !contact.IsRegisteredForTax;
            }
            this.purchaseOrder.calculateInvoiceTotal();
        }
    }

    // @ts-ignore TS7006
    taxRatesChanged(evt, item) {
        item.TaxRates = evt;
    }

    // @ts-ignore TS7006
    deliveryRatesChanged(evt) {
        this.purchaseOrder.DeliveryTaxRates = evt;
    }

    loadInvoiceItems() {
        // @ts-ignore TS7034
        let allInvoiceItems = [];
        this.purchaseOrder.PurchaseOrderInvoices.forEach((invoice) => {
            if (!invoice.IsDeleted) {
                // @ts-ignore TS7005
                allInvoiceItems = allInvoiceItems.concat(invoice.PurchaseOrderInvoiceItems);
            }
        });

        this.purchaseOrder.PurchaseOrderItems.forEach((i) => {
            // @ts-ignore TS7005
            i._invoiceItems = allInvoiceItems.filter((invoiceItem) => {
                return invoiceItem.ID_PurchaseOrderItem === i.ID_PurchaseOrderItem;
            });
        });
    }

    loadContactPersons() {
        if (this.purchaseOrder.ID_Contact) {
            this.repoContacts.GetContactPersons(this.purchaseOrder.ID_Contact).then((data) => {
                this.contactPeople = data.results;
            });
        } else {
            this.contactPeople = [];
        }
    }

    // @ts-ignore TS7006
    dropOrderItem($event) {
        // Only index of undeleted items matter for sorting
        const undeletedTasks = this.purchaseOrder.PurchaseOrderItems.filter((item) => item.IsDeleted === false);
        const dragItem = undeletedTasks[$event.previousIndex];
        const dropItem = undeletedTasks[$event.currentIndex];
        // @ts-ignore TS2345
        this.changeItemOrder(dragItem, dropItem);
    }

    changeItemOrder(dragItem: PurchaseOrderItem, dropItem: PurchaseOrderItem) {
        if (!dragItem || !dropItem) return;
        if (dragItem === dropItem) return;
        moveInArray(this.purchaseOrder.PurchaseOrderItems, dragItem, dropItem);
        this.orderPurchaseOrderItems();
    }

    orderPurchaseOrderItems() {
        for (let i = 0; i < this.purchaseOrder.PurchaseOrderItems.length; i++) {
            // @ts-ignore TS2532
            this.purchaseOrder.PurchaseOrderItems[i].Order = i;
        }
    }

    onSupplierChanged(contactId?: Uuid) {
        this.#assignContact(contactId);

        if (this.purchaseOrder.entityAspect.entityState.name !== 'Unchanged' && this.purchaseOrder.ContactViaGql) {
            const contact = this.purchaseOrder.ContactViaGql;
            this.purchaseOrder.SupplierAttention = contact.Name!;

            this.purchaseOrder.IsTaxFree = !contact.IsRegisteredForTax;
            this.purchaseOrder.calculateInvoiceTotal();

            this.setAccountCode();
        }

        this.loadContactPersons();
    }

    private setAccountCode() {
        const contact = this.purchaseOrder.ContactViaGql;

        if (contact?.AccountCode) {
            this.purchaseOrder.AccountCode = contact.AccountCode;
            return;
        }

        if (!this.accountingSyncSetting) {
            return;
        }

        if (this.accountingSyncSetting.isPurchaseOrderAccountCodeSeparate && contact?.ContactGroup) {
            this.purchaseOrder.AccountCode =
                contact.ContactGroup.toLowerCase().indexOf('contractor') >= 0
                    ? this.accountingSyncSetting.purchaseOrderAccountCodeContractor
                    : this.accountingSyncSetting.purchaseOrderAccountCode;
            return;
        }

        if (!this.purchaseOrder.AccountCode || !contact?.ContactGroup) {
            this.purchaseOrder.AccountCode = this.accountingSyncSetting.purchaseOrderAccountCode;
        }
    }

    addNewContact(value: string) {
        this.contactsService.newContact({ Name: value, preventOpen: true }).then(
            (contact: ContactLegacy) => {
                this.contacts.push(contact);
                this.purchaseOrder.ID_Contact = contact.ID_Contact!;
                this.purchaseOrder.ContactViaGql = contact;
                this.repoJobs.setSupplierAttentionOnPurchaseOrder(this.purchaseOrder, contact);
                this.onSupplierChanged(contact.ID_Contact!);
            },
            () => ({})
        );
    }

    loadAccounts() {
        this.integrationsService.GetConnectedAccountingProvider().then((result: Integration | null) => {
            if (result !== null) {
                const provider = result.provider.toString();
                this.repoAccountingSync.GetSetting(true).then(() => {
                    this.accountingSyncSetting = this.sharedData.AccountingSyncSetting;
                });
                this.repoAccountingSync.GetAccounts(provider, true).then((accResult?: { expense: any[]; income: any[] }) => {
                    if (accResult) {
                        this.expenseAccounts = accResult.expense;
                        if (!this.purchaseOrder.AccountCode) this.setAccountCode();
                    }
                });
            }
        });
    }

    setPermissions() {
        combineLatest([
            this.permissionService.getState('jobs.maintain-purchase-orders.create-purchase-order'),
            this.permissionService.getState('jobs.maintain-work-orders.create-work-order'),
            this.permissionService.getState('jobs.maintain-purchase-orders.modify-purchase-order'),
            this.permissionService.getState('jobs.maintain-work-orders.modify-work-order'),
            this.permissionService.getState('jobs.maintain-purchase-orders.send-purchase-order'),
            this.permissionService.getState('jobs.maintain-work-orders.send-work-order'),
            this.permissionService.getState('jobs.maintain-purchase-orders.receipt-purchase-order'),
            this.permissionService.getState('jobs.maintain-work-orders.receipt-work-order'),
            this.permissionService.getState('jobs.maintain-purchase-orders.cancel-purchase-order'),
            this.permissionService.getState('jobs.maintain-work-orders.cancel-work-order'),
            this.featureService.getState('jobs.maintain-purchase-orders.send-purchase-order'),
            this.featureService.getState('jobs.maintain-work-orders.send-work-order'),
            this.permissionService.getState('jobs.maintain-job-documents.view-documents'),
            this.permissionService.getState('jobs.maintain-job-documents.delete-documents'),
            this.permissionService.getState('jobs.maintain-job-documents.add-documents'),
        ]).subscribe((val) => {
            // @ts-ignore TS2322
            this.permissions.canCreatePurchaseOrder = val[0];
            // @ts-ignore TS2322
            this.permissions.canCreateWorkOrder = val[1];
            this.permissions.canModifyPurchaseOrder =
                val[2] ||
                (this.permissions.canCreatePurchaseOrder &&
                    (this.purchaseOrder.CreatedBy === this.sharedData.UserData.user.ID_User ||
                        this.purchaseOrder.entityAspect.entityState.isAdded()));
            this.permissions.canModifyWorkOrder =
                val[3] ||
                (this.permissions.canCreateWorkOrder &&
                    (this.purchaseOrder.CreatedBy === this.sharedData.UserData.user.ID_User ||
                        this.purchaseOrder.entityAspect.entityState.isAdded()));
            // @ts-ignore TS2322
            this.permissions.canSendPurchaseOrder = val[4];
            // @ts-ignore TS2322
            this.permissions.canSendWorkOrder = val[5];
            // @ts-ignore TS2322
            this.permissions.canReceiptPurchaseOrder = val[6];
            // @ts-ignore TS2322
            this.permissions.canReceiptWorkOrder = val[7];
            // @ts-ignore TS2322
            this.permissions.canCancelPurchaseOrder = val[8];
            // @ts-ignore TS2322
            this.permissions.canCancelWorkOrder = val[9];
            // @ts-ignore TS2322
            this.features.canSendPurchaseOrder = val[10];
            // @ts-ignore TS2322
            this.features.canSendWorkOrder = val[11];
            // @ts-ignore TS2322
            this.permissions.canViewDocuments = val[12];
            // @ts-ignore TS2322
            this.permissions.canDeleteDocuments = val[13];
            // @ts-ignore TS2322
            this.permissions.canAddDocuments = val[14];

            this.setType();
            this.setIsAllowedToSave();
            this.setIsAllowedToSend();
            this.setIsAllowedToAddItem();
            this.setIsAllowedToReceipt();
            this.setOrderFormDisabled();
            this.setOrderTypeDisabled();
        });
    }

    setIsAllowedToSave() {
        if (this.type.value === 'purchase') this.isAllowedToSave = this.permissions.canModifyPurchaseOrder;
        else if (this.type.value === 'work') this.isAllowedToSave = this.permissions.canModifyWorkOrder;
        else this.isAllowedToSave = true;

        if (
            this.purchaseOrder.OrderNumber === 0 &&
            ((this.type.value === 'purchase' && this.permissions.canCreatePurchaseOrder) ||
                (this.type.value === 'work' && this.permissions.canCreateWorkOrder))
        )
            this.isAllowedToSave = true;
    }

    setIsAllowedToSend() {
        if (this.type.value === 'purchase')
            this.isAllowedToSend = this.permissions.canSendPurchaseOrder && this.features.canSendPurchaseOrder;
        else if (this.type.value === 'work') this.isAllowedToSend = this.permissions.canSendWorkOrder && this.features.canSendWorkOrder;
        else this.isAllowedToSend = true;
    }

    setIsAllowedToAddItem() {
        if (this.type.value === 'purchase') this.isAllowedToAddItem = this.permissions.canModifyPurchaseOrder;
        else if (this.type.value === 'work') this.isAllowedToAddItem = this.permissions.canModifyWorkOrder;
        else this.isAllowedToAddItem = true;
    }

    setIsAllowedToReceipt() {
        if (this.type.value === 'purchase') this.isAllowedToReceipt = this.permissions.canReceiptPurchaseOrder;
        else if (this.type.value === 'work') this.isAllowedToReceipt = this.permissions.canReceiptWorkOrder;
        else this.isAllowedToReceipt = true;
    }

    setOrderFormDisabled() {
        this.orderFormDisabled = false;

        if (
            (this.type.value === 'purchase' && !this.permissions.canModifyPurchaseOrder) ||
            (this.type.value === 'work' && !this.permissions.canModifyWorkOrder)
        )
            this.orderFormDisabled = true;

        //Recheck if they're able to create a PO and is a new PO
        if (
            this.purchaseOrder.OrderNumber === 0 &&
            ((this.type.value === 'purchase' && this.permissions.canCreatePurchaseOrder) ||
                (this.type.value === 'work' && this.permissions.canCreateWorkOrder))
        )
            this.orderFormDisabled = false;
    }

    setOrderTypeHidden() {
        if (this.featureService.isAvailable('compact-jobs')) {
            this.orderTypeDisabled = true;
            this.orderTypeHidden = true;
            this.type.value = 'purchase';
            return;
        }
    }

    setOrderTypeDisabled() {
        this.orderTypeDisabled = false;

        if (
            (this.type.value === 'purchase' && !this.permissions.canModifyPurchaseOrder) ||
            (this.type.value === 'work' && !this.permissions.canModifyWorkOrder)
        )
            this.orderTypeDisabled = true;

        //Recheck if they're able to create a PO and is a new PO
        if (
            this.purchaseOrder.OrderNumber === 0 &&
            ((this.type.value === 'purchase' && this.permissions.canCreatePurchaseOrder) ||
                (this.type.value === 'work' && this.permissions.canCreateWorkOrder))
        )
            this.orderTypeDisabled = false;

        if (
            !this.importSettings &&
            (this.purchaseOrder.OrderStatus === 'Received' ||
                this.purchaseOrder.OrderStatus === 'Cancelled' ||
                this.purchaseOrder.OrderStatus === 'PartReceived' ||
                this.purchaseOrder.AccSyncData)
        )
            this.orderTypeDisabled = true;

        // Set up disabled
        this.types.forEach((t) => {
            if (t.value === 'Sent' && this.permissions.canSendPurchaseOrder) {
                t.disabled = true;
            }
        });
    }

    setType() {
        let newType = this.repoJobs.GetPurchaseOrderType(this.purchaseOrder.OrderType);

        if (!newType) {
            this.purchaseOrder.OrderType = this.types[0].value;
            newType = this.types[0];
        }

        let newStatus = newType!.statuses[0]; // default new status when the type is changed
        if (this.type) {
            // type has changed
            // Change status so it matches the type set
            // Use index matching to change statuses
            const currentStatusIndex = this.type.statuses.indexOf(this.purchaseOrder.OrderStatus);
            if (currentStatusIndex !== -1) {
                // @ts-ignore TS2532
                if (newType.statuses.length >= currentStatusIndex + 1) newStatus = newType.statuses[currentStatusIndex];
            }
            // @ts-ignore TS2322
            this.purchaseOrder.OrderStatus = newStatus;
        }
        this.type = newType;
        // @ts-ignore TS7034
        const statuses = [];
        //this.orderStatuses = this.type.statuses;
        // @ts-ignore TS7006
        this.type.statuses.forEach((status) => {
            const isStatusDisabled =
                (status === 'Sent' && !this.permissions.canSendPurchaseOrder && this.type.value === 'purchase') ||
                (status === 'Received' && !this.permissions.canReceiptPurchaseOrder && this.type.value === 'purchase') ||
                (status === 'Cancelled' && !this.permissions.canCancelPurchaseOrder && this.type.value === 'purchase') ||
                (status === 'Sent' && !this.permissions.canSendWorkOrder && this.type.value === 'work') ||
                (status === 'Received' && !this.permissions.canReceiptWorkOrder && this.type.value === 'work') ||
                (status === 'Cancelled' && !this.permissions.canCancelWorkOrder && this.type.value === 'work') ||
                (this.purchaseOrder.HasInvoices && status === 'Unsent') ||
                (this.purchaseOrder.OrderStatus === 'PartReceived' &&
                    this.purchaseOrder.HasInvoices &&
                    (status === 'Sent' || status === 'Unsent')) ||
                (this.purchaseOrder.OrderStatus === 'Received' &&
                    this.purchaseOrder.HasInvoices &&
                    (status === 'Sent' || status === 'Unsent')) ||
                (this.purchaseOrder.OrderStatus === 'Cancelled' &&
                    this.purchaseOrder.HasInvoices &&
                    (status === 'Sent' || status === 'Unsent')) ||
                (this.purchaseOrder.OrderStatus === 'Cancelled' &&
                    !this.purchaseOrder.HasInvoices &&
                    (status === 'Sent' || status === 'Received'));

            statuses.push({
                name: status,
                disabled: isStatusDisabled,
            });
        });
        // @ts-ignore TS7005
        this.orderStatuses = statuses;
    }

    _getParentTasks() {
        // @ts-ignore TS2532
        const filtered = this.purchaseOrder.Job.JobItems.filter((i) => {
            return !i.IsDeleted && i.IsParent && i.Description;
        });
        const ordered = _.orderBy(filtered, ['OrderNumber']);

        const map = ordered.map((ordered) => ({ ID_ParentTask: ordered.ID_JobItem, Description: ordered.Description }));
        return map;
    }

    // @ts-ignore TS7006
    setParentTaskId(item, selectedItem) {
        item.ID_ParentTask = selectedItem.ID_ParentTask;
        item.ParentTask = selectedItem.Description;
    }

    // @ts-ignore TS7006
    setParentTaskIdOnChange(item) {
        if (item.ParentTask === '') {
            item.ID_ParentTask = null; // Empty Parent Task, make sure ID_ParentTask is blank
        } else if (item.ParentTask !== '') {
            const parentTask = _.find(this.parentTasks, {
                Description: item.ParentTask,
            });

            if (parentTask) {
                item.ID_ParentTask = parentTask.ID_ParentTask; // Found matching category based on description
            } else item.ID_ParentTask = null; // No matching category, blank ID_Parent task so new one is created
        }
    }

    orderStatusChanged() {
        if (!this.editing && (this.purchaseOrder.OrderStatus === 'Unsent' || this.purchaseOrder.OrderStatus === 'Completed')) {
            this.editing = true;
        }

        if ((this.editing && this.purchaseOrder.OrderStatus === 'Received') || this.purchaseOrder.OrderStatus === 'Sent') {
            // Need to check if a supplier has been entered, or any order items
            if (!this.purchaseOrder.ID_Contact) {
                this.dialogService.show({
                    title: 'No supplier selected',
                    text: `Please select a supplier first before marking the order as ${this.purchaseOrder.OrderStatus}`,
                    showCancel: false,
                    type: 'warning',
                });
                // Change status back
                setTimeout(() => {
                    // ng-select needs this timeout to reset status
                    this.purchaseOrder.OrderStatus = 'Unsent';
                });

                return;
            }
            if (
                !this.purchaseOrder.PurchaseOrderItems.some((i) => {
                    return !i.IsDeleted;
                })
            ) {
                this.dialogService.show({
                    title: 'No order items',
                    text: `Please enter at least 1 order item before marking the order as ${this.purchaseOrder.OrderStatus}`,
                    showCancel: false,
                    type: 'warning',
                });
                // Change status back
                setTimeout(() => {
                    // ng-select needs this timeout to reset status
                    this.purchaseOrder.OrderStatus = 'Unsent';
                });
                return;
            }

            this.editing = false;
        }

        if (this.purchaseOrder.OrderStatus === 'Received') {
            if (!this.purchaseOrder.HasInvoices) {
                this.purchaseOrder.OrderStatus = 'Sent';
                this.addOrderInvoice();
            }
        }

        if (this.purchaseOrder.OrderStatus === 'PartReceived' || this.purchaseOrder.OrderStatus === 'Received') {
            this.storesService.syncIntegrations();
        }
        //  display . message about setting to received/completed
        this.statusChangedToReceived = this.purchaseOrder.OrderStatus === 'Received' || this.purchaseOrder.OrderStatus === 'Completed';
    }

    // @ts-ignore TS7006
    showCostItemsModal(currentCostItem) {
        const search = currentCostItem.Description === 'New Item' ? '' : currentCostItem.Description;
        this.priceListService
            .browse(search, true)
            .then((selectedItems: any[]) => {
                if (selectedItems && selectedItems.length) {
                    this.setCostItem(currentCostItem, selectedItems[0]);
                }
            })
            .catch(() => ({}));
    }

    // @ts-ignore TS7006
    setupCostItems(search) {
        this.costItemSuggestions$ = new Observable<any>((observer: Subscriber<string>) => {
            // Runs on every search
            observer.next(search);
        }).pipe(
            debounceTime(500),
            distinctUntilChanged(),
            mergeMap(async (token: string) => {
                return await this.searchCostItems(token);
            })
        );
    }

    // @ts-ignore TS7006
    searchCostItems(value) {
        return this.cataloguesService.RecommendCostItems(value, 10, false, true);
    }

    setCostItem(orderItem: PurchaseOrderItem, match: any) {
        const costItem = match.item || match;
        const id = costItem.ID_CostItem || costItem.costItemId;
        // set properties from selection
        orderItem.ID_CostItem = id;
        orderItem.Description = costItem.description;
        orderItem.UOM = costItem.uom;
        orderItem.UnitCost = costItem.unitCost;
        orderItem.CostItemType = this.taxService.validateCostItemType(costItem.costItemType);
        orderItem.ItemCode = costItem.itemCode;

        // Get latest version of item from server
        this.cataloguesService.GetCostItem(id).then((data) => {
            // @ts-ignore TS2531
            if (data.results.length > 0) {
                // @ts-ignore TS2531
                const item = data.results[0];

                orderItem.ID_CostItem = item.ID_CostItem;
                orderItem.Description = item.Description;
                orderItem.UOM = item.UOM;
                orderItem.UnitCost = item.UnitCost;
                orderItem.CostItemType = this.taxService.validateCostItemType(item.CostItemType);
                orderItem.ItemCode = item.ItemCode;
            }
        });
    }

    clearItemCode(orderItem: PurchaseOrderItem) {
        orderItem.ItemCode = null;
    }

    showCalculator(item: PurchaseOrderItem) {
        const config: BxCalculatorConfig = {
            expression: item.UnitsExpression || item.Quantity.toFixed(3).toString(),
            title: item.Description,
            item: item,
        };
        this.openCalculatorV2(config);
    }

    private openCalculatorV2(config: BxCalculatorConfig) {
        const estimate = this.purchaseOrder.Job.Estimate;
        (estimate ? this.estimateMeasurementCategoryService.getEstimateMeasurementCategoriesByEstimateId(estimate.ID_Estimate) : of(null))
            // @ts-ignore TS2554
            .pipe(take(1))
            // @ts-ignore TS2554
            .subscribe((categories: EstimateMeasurementCategoryVM[]) => {
                if (categories) {
                    this.estimateMeasurementCalculatorService.updateConfigExpressionRefs(config, categories);
                }

                this.bxCalculatorService.open(config).then(
                    (result) => {
                        result.item.UnitsExpression = result.expression;
                        result.item.Quantity = result.value;
                    },
                    (cancel) => ({})
                );
            });
    }

    unitCostChanged(evt: number, item: PurchaseOrderItem) {
        /* This a hacky fix to prevent autofill from updating the unit cost field.
        all browsers seems to be behaving differently with autofill 
        so no clear fix has been found yet */
        item.UnitCost = evt ?? 0;
    }

    updateDeliverCost(evt: number) {
        this.purchaseOrder.DeliveryCost = evt ?? 0;
    }

    doTakeOff(item: PurchaseOrderItem) {
        this.takeOffService
            .doTakeOff({
                referenceId: this.job.ID_Estimate,
                Id: item.ID_PurchaseOrderItem,
                measurementId: item.ID_PurchaseOrderItem,
                description: item.Description,
                uom: item.UOM,
            })
            .then(
                // @ts-ignore TS2554
                (result: TakeOffMeasurement) => {
                    // @ts-ignore TS2554
                    item.Quantity = result.total;
                    if (!item.UOM || item.UOM.toLowerCase() !== result.uom) item.UOM = result.uom;
                },
                (error: any) => {
                    if (error) this.logger.warning(error);
                }
            );
    }

    // TODO:: move to shared component to slim the product
    ok(send?: boolean) {
        if (this.isSaving) return;
        this.isSaving = true;
        if (send && !this.sharedData.UserData.identityInfo.email_verified) {
            this.isSaving = false;
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        const msg = this.invalidMessage();
        if (msg) {
            this.logger.warning(msg);
            this.isSaving = false;
            return;
        }

        this.purchaseOrder.send = send;
        this.storesService.updatePOStatus(this.purchaseOrder);
        this.bsModalRef.hide();
        this.action.emit({ cancelled: false });
    }

    cancel() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: true });
    }

    addOrderItem() {
        const order = this.purchaseOrder.PurchaseOrderItems.length
            ? // @ts-ignore TS2532
              _.sortBy(this.purchaseOrder.PurchaseOrderItems, 'Order').reverse()[0].Order + 1
            : 0;

        const data = {
            Quantity: 1,
            Order: order,
        };

        const newItem = this.repoJobs.CreatePurchaseOrderItem(this.purchaseOrder, data);
        this.orderPurchaseOrderItems();
        this.purchaseOrder.calculateTotal();
        this.itemCount += 1;
        focusElement(newItem.ID_PurchaseOrderItem);
    }

    // @ts-ignore TS7006
    deleteOrder(item) {
        this.itemCount -= 1;
        item.IsDeleted = true;
    }

    invalidMessage() {
        const supplierMsg =
            this.purchaseOrder.OrderType === 'purchase' ? 'You need to select a supplier' : 'You need to assign this order to someone';
        if (!(this.purchaseOrder.ContactViaGql ?? this.purchaseOrder.ID_Contact)) return supplierMsg;
        const emptyItems = _.filter(this.purchaseOrder.PurchaseOrderItems, (item) => {
            return !item.IsDeleted && !item.Description;
        });
        if (emptyItems.length > 0) return 'Order items cannot be empty';
        return undefined;
    }

    async addOrderInvoice() {
        await this.purchaseOrdersInvoiceService.addOrderInvoice(this.purchaseOrder).catch(() => ({}));
        this.loadInvoiceItems();
        this.setOrderFormDisabled();
        this.purchaseOrder.calculateInvoiceTotal();
        this.storesService.syncIntegrations();
    }

    async editOrderInvoice(invoice: PurchaseOrderInvoice) {
        await this.purchaseOrdersInvoiceService.viewOrderInvoice(invoice, !!this.importSettings).catch(() => ({}));
        this.loadInvoiceItems();
    }

    // @ts-ignore TS7006
    deleteOrderInvoice(evt, invoice) {
        evt.stopPropagation();
        const params = {
            title: 'Delete invoice/receipt?',
            text: 'You can still cancel out of this order to undo this if you want to.',
        };
        const warning = {
            title: 'Delete invoice/receipt?',
            text: 'This item has been synced to your accounting system. Are you sure you wish to delete this invoice/receipt.',
        };

        this.dialogService.show(params).then(
            () => {
                if (invoice.AccSyncData && invoice.AccSyncData !== 'Imported') {
                    setTimeout(() => {
                        this.dialogService.show(warning).then(
                            () => {
                                this._deleteOrderInvoice(invoice);
                            },
                            () => ({})
                        );
                    }, 500);
                } else {
                    this._deleteOrderInvoice(invoice);
                }
            },
            () => ({})
        );
    }

    // @ts-ignore TS7006
    _deleteOrderInvoice(invoice) {
        invoice.IsDeleted = true;
        this.purchaseOrder.calculateInvoiceTotal();
        if (this.purchaseOrder.OrderStatus === 'PartReceived' && !this.purchaseOrder.HasInvoices) this.purchaseOrder.OrderStatus = 'Sent';
        // resetting order status dropdown
        if (!this.purchaseOrder.HasInvoices) {
            this.setType();
        }

        this.loadInvoiceItems();
    }

    // @ts-ignore TS7006
    changeStatus(s) {
        this.purchaseOrder.OrderStatus = s;
    }

    // @ts-ignore TS7006
    saveAndCloseDisabled(editJobPurchaseOrderForm) {
        return this.isSaving || !this.isAllowedToSave || !editJobPurchaseOrderForm.valid || this.purchaseOrder.ID_JobPayment;
    }

    // @ts-ignore TS7006
    saveAndSendDisabled(editJobPurchaseOrderForm) {
        return (
            this.isSaving ||
            !this.isAllowedToSave ||
            !this.isAllowedToSend ||
            !editJobPurchaseOrderForm.valid ||
            this.purchaseOrder.ID_JobPayment ||
            this.purchaseOrder.OrderStatus === 'Cancelled'
        );
    }

    validateCategories() {
        return this.purchaseOrder.PurchaseOrderItems.some((p) => !p.IsDeleted && !p.ParentTask);
    }

    handleAddressChange(event: google.maps.places.Place) {
        const addressComponents = getAddressComponents(event);
        const state = this.sharedData.Common.StatesInfo.find(
            // @ts-ignore TS7006
            (s) => s.code === addressComponents.stateName || s.name === addressComponents.stateName
        );
        // @ts-ignore TS2322
        this.purchaseOrder.DeliveryAddress1 = addressComponents.addressLine1;
        this.purchaseOrder.DeliveryCityTown = addressComponents.city;
        this.purchaseOrder.DeliveryPostCode = addressComponents.postcode;
        this.purchaseOrder.DeliveryState = state ? state.value : '';
    }
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule,
        SharedComponentsModule,
        TypeaheadModule,
        NgSelectModule,
        NgxSelectModule,
        TaxRateSelectorModule,
        TooltipModule,
        CurrencyInputModule,
        DragDropModule,
        SingleClickModule,
        CatalogueItemLinkTileModule,
        BxContactCardStatusModule,
        UiEstimateItemPillModule,
        AutoFocusDirective,
        BxAddressInputComponent,
    ],
    declarations: [PurchaseOrderDetailComponent],
    exports: [PurchaseOrderDetailComponent],
})
export class PurchaseOrderDetailModule {}
